import * as AppConstants from "AppConstants";

// @since NEXT_VERSION
export const getUrlToFetchAllDepartments = (status) => {
    const base = AppConstants.FETCH_ALL_DEPARTMENTS_ENDPOINT;
    return status ? `${base}?status=${encodeURIComponent(status)}` : base;
};

// @since NEXT_VERSION
export const getUrlToCreateDepartment = () => AppConstants.CREATE_DEPARTMENT_ENDPOINT;

// @since NEXT_VERSION
export const getUrlToUpdateDepartment = (departmentId) =>
    AppConstants.UPDATE_DEPARTMENT_ENDPOINT
        .replace(AppConstants.DEPARTMENT_ID_PLACEHOLDER, departmentId);

// @since NEXT_VERSION
export const getUrlToDeleteDepartment = (departmentId) =>
    AppConstants.DELETE_DEPARTMENT_ENDPOINT
        .replace(AppConstants.DEPARTMENT_ID_PLACEHOLDER, departmentId);
